import { createContext, useContext, useState } from "react";

const  CashBackContext = createContext()  

export const  CashBackProvider = ({walletCall , walletData , children})=> {
    const [currentPage , setCurrentPage] = useState('')
     const [loader , setLoader] = useState(false)
     const [popupOpen , setpopupOpen] = useState(false)

    return (
        <>
        <CashBackContext.Provider value={{ setpopupOpen , walletData, popupOpen, walletCall ,setCurrentPage ,currentPage , loader  , setLoader }} >
            {children}
        </CashBackContext.Provider>
        </>
    )
}

export const useCashBackProvider = ()=> useContext(CashBackContext)